function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './CustomerCareSection.css';
import React, { useContext } from 'react';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import CustomerCareCard from './CustomerCareCard';
var ContactSection = function ContactSection(props) {
  var _props$item = props.item,
    leftTitle = _props$item.leftTitle,
    rightTitle = _props$item.rightTitle,
    leftItems = _props$item.leftItems,
    rightItems = _props$item.rightItems;
  var sitecoreContext = useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  return /*#__PURE__*/React.createElement("div", {
    className: "contact-section row ".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, leftItems.items.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "contact-section__col col-12 col-lg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "contact-section__group "
  }, leftTitle.jss.value && /*#__PURE__*/React.createElement("h2", {
    className: "contact-section__heading"
  }, leftTitle.jss.value), /*#__PURE__*/React.createElement("div", {
    className: "contact-section__cards"
  }, leftItems.items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(CustomerCareCard, _extends({
      key: index
    }, item));
  })))), rightItems.items.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "contact-section__col col-12 col-lg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "contact-section__group"
  }, rightTitle.jss.value && /*#__PURE__*/React.createElement("h2", {
    className: "contact-section__heading"
  }, rightTitle.jss.value), /*#__PURE__*/React.createElement("div", {
    className: "contact-section__cards"
  }, rightItems.items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(CustomerCareCard, _extends({
      key: index
    }, item));
  })))));
};
export default ContactSection;
var commonStyles = "c1ef900m";
var ltrStyles = "lrnaw41";
var rtlStyles = "r1djth6h";